import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";
import MDInput from "common/components/MD/MDInput";
import MDButton from "common/components/MD/MDButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Alert from '@mui/material/Alert';

import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ReactHookFormCheckBox from "common/components/mycomponents/ReactHookFormCheckBox"
import HeaderForm from "layouts/components/HeaderForm";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


//validazione lato client
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// Data
import UtilityService from "services/API/utility/UtilityService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import ReactHookFormSelect from "common/components/mycomponents/ReactHookFormSelect";
import { Icon, MenuItem } from "@mui/material";
import ModuliObbligatoriFieraTable from "./ModuliObbligatoriFieraTable";
import ModuloEditModal from "./ModuloEditModal";
import ModuliList from "./ModuliList";

function ManifestazioneEdit() {
    const location = useLocation();
    const navigate = useNavigate();

    const { modo, soggetto } = location.state;

    // user state for form
    const [manifestazione, setManifestazione] = useState({
        nome_manifestazione: '', iscrizioni_aperte: false, attiva: false, pdf_regolamento: '', nome_pdf_regolamento: '',
        pdf_regolamento_tecnico: '', nome_pdf_regolamento_tecnico: '', moduli_obbligatori: [{ idFile: 0, tipo_file: '', nome_file: '' }]
    });

    const [lista_moduli, setLista_moduli] = useState([{ idFile: 0, tipo_file: '', nome_file: '' }]);

    const [open, setOpen] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (soggetto != null) {
            console.log("soggetto non nullo: id=" + soggetto.nome_manifestazione);
            retrive_soggetto();
        } else {
            console.log("soggetto nullo");
        }
    }, [soggetto]);

    async function retrive_soggetto() {
        console.log("Cambiata man->seleziono i dettagli :" + soggetto.nome_manifestazione);
        if (soggetto.nome_manifestazione != null) {
            const response = await UtilityService.seleziona_dettagli_man(soggetto.nome_manifestazione);
            response.errors ? console.log(response.errors) : retrive(response.data);
        }
    }



    function retrive(data) {
        console.log("RETRIVE =" + data.nome_manifestazione);

        setManifestazione({
            nome_manifestazione: data.nome_manifestazione,
            iscrizioni_aperte: data.iscrizioni_aperte,
            attiva: data.attiva,
            stato_manifestazione: data.stato_manifestazione,
            stato_manifestazione_string: data.stato_manifestazione_string,
            pdf_regolamento: data.pdf_regolamento, nome_pdf_regolamento: data.nome_pdf_regolamento,
            pdf_regolamento_tecnico: data.pdf_regolamento_tecnico, nome_pdf_regolamento_tecnico: data.nome_pdf_regolamento_tecnico,
            moduli_obbligatori: data.moduli_obbligatori
        })
        setLista_moduli(data.moduli_obbligatori);
        console.log("selezionata  " + data.nome_manifestazione);

    }



    // effect runs when user state is updated
    useEffect(() => {
        // reset form with user data
        setValue("nome_manifestazione", manifestazione.nome_manifestazione);
        setValue("iscrizioni_aperte", manifestazione.iscrizioni_aperte);
        setValue("attiva", manifestazione.attiva);
        setValue("pdf_regolamento", manifestazione.pdf_regolamento);
        setValue("nome_pdf_regolamento", manifestazione.nome_pdf_regolamento);
        setValue("pdf_regolamento_tecnico", manifestazione.pdf_regolamento_tecnico);
        setValue("nome_pdf_regolamento_tecnico", manifestazione.nome_pdf_regolamento_tecnico);
        setValue("stato_manifestazione", manifestazione.stato_manifestazione);



    }, [manifestazione]);


    const righe = [];


    lista_moduli.forEach(m => {

        righe.push({
            key: m.idFile,
            modulo: m,
            nome_modulo: m.nome_modulo,
            nome_file: m.nome_file,

        })

    });

    const ppTableData = {
        rows: righe,

        columns: [

            { Header: "", accessor: "icona", width: "5%", align: "left", id: "mo_0" },
            { Header: "Modulo", accessor: "nome_modulo", width: "15%", align: "left", enableGlobalFilter: false, id: "mo_1", disableSortBy: true },
            { Header: "Modulo da Compilare", accessor: "modulo_compilato", align: "left", with: "50%", id: "mo_2" }
        ],



    };

    function aggiungi_riga() {

        handleShow();
     
    }
    const handleShowClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Funzione per aggiungere un nuovo oggetto alla lista
    const handleAddModulo = (newObject) => {
        console.log("handleAddModulo");
    
        setLista_moduli((prevObjects) => [...prevObjects, newObject]);
    
        handleShowClose(); // Chiudi la modale dopo il salvataggio
    };

const handleRemoveModulo = (idFile) => {

      UtilityService.removeModulo(idFile)
                       .then(response => {
                          alert("File rimosso correttamente!")
                       })
                       .catch(errore => {
                              console.log(errore);
                            alert("Errore nella rimozione del file !"+errore)
                       });
        var filtrato= lista_moduli.filter(function(valore, indice,vett){
            return valore.idFile!= idFile;
            });
        setLista_moduli(filtrato);
    
    };


    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const validationSchema = Yup.object().shape({

        nome_manifestazione: Yup.string().required('Nome richiesto').max(100, 'Nome non deve superare 100 caratteri'),

        pdf_regolamento: Yup.mixed().nullable().when("$isPresent", {
            is: (val) => {
                return modo === 'new';
            },
            then: (s) => s.required('VALIDATION_FIELD_REQUIRED')
                .test("fileSize", "The file is too large", (value) => {
                    return value && value[0].size <= 2000000;
                })
                .test("type", "Only the following formats are accepted: .pdf ", (value) => {
                    return value && (
                        value[0].type === 'application/pdf'
                    );
                }),
            otherwise: (s) => s,
        }),


        pdf_regolamento_tecnico: Yup.mixed().nullable()
            .test("fileSize", "The file is too large", (value) => {
                // Se non c'è un file, non applicare la validazione delle dimensioni
                // if (!value || value==null) return true;

                // Verifica le dimensioni solo se è presente un file (max 2MB)
                //   return value[0].size <= 5 * 1024 * 1024;
                // return value==null || value[0].size <= 5000000;
                return !value || value[0].size <= 2000000;
            })
            .test("type", "Only the following formats are accepted: .pdf ", (value) => {
                return (
                    !value || value == null || value[0].type === 'application/pdf');
            }),

    })

    const {
        register, //register inputs
        reset, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema),
    });


    //sono quelli lato server
    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);


    const insert = (formData) => {
        setError(null);
        var data = {
            nome_manifestazione: formData.nome_manifestazione,
            iscrizioni_aperte: formData.iscrizioni_aperte || false,
            pdf_regolamento: formData.pdf_regolamento,
            pdf_regolamento_tecnico: formData.pdf_regolamento_tecnico,
            attiva: formData.attiva || false,
            stato_manifestazione: formData.stato_manifestazione,
        };

        if (modo === 'new') {
            console.log("Inserisci ");
            UtilityService.createMan(data)
                .then(response => {
                    handleResponse(response, 'INS');
                })
                .catch(errore => {
                    handleError(errore);
                });
        } else {
            console.log("update manifestazione ");
            console.log("iscrizioni_aperte=" + data.iscrizioni_aperte);
            UtilityService.updateMan(manifestazione.nome_manifestazione, data)
                .then(response => {
                    handleResponse(response, 'MOD');
                })
                .catch(errore => {
                    handleError(errore);
                });

        }
    };

    function handleClose() {

        setOpen(false);
    }
    function handleConfirm() {

        setConfirm(true);
        setOpen(false);
        deleteLoc();
    }

    const handleOpen = () => {
        console.log("OPEN DIALOG");
        setOpen(true);
    }

    const deleteLoc = () => {
        setError(null);

        if (modo === 'edit') {

            console.log("delete loc");
            UtilityService.remove(manifestazione.nome_manifestazione)
                .then(response => {
                    console.log("handleResponse");
                    handleResponse(response, 'DEL');
                })
                .catch(errore => {
                    console.log("handleError");
                    handleError(errore);
                });


        }
    };


    function handleResponse(response, op) {
        console.log(response.data);
        navigate(`/manifestazioni`, { state: { submitted: true, salvato: op } });
    }

    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);

        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log("ERROR:RESPONSE" + error.response.data);
            setErrorMessage(error.response.data);

        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log("ERROR:REQUEST" + error.request);
            setErrorMessage(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            setErrorMessage(error.message);
        }

    }

    const annulla = () => {
        console.log("ANNULLA");
        navigate("/manifestazioni");

    }

    const download_pdf_regolamento = () => {
        download_pdf("REGOLAMENTO");

    }
    const download_pdf_rt = () => {
        download_pdf("R_TECNICO");

    }

    async function download_pdf(tipo_file) {



        UtilityService.seleziona_file_man(manifestazione.nome_manifestazione, tipo_file)
            .then(response => {

                return response.data;
            })
            .then(blob => {

                var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                var url = URL.createObjectURL(blobb);
                var a = document.createElement('a');
                a.href = url;
                a.target = "_blank";
                if (tipo_file === "REGOLAMENTO")
                    a.download = manifestazione.nome_pdf_regolamento;
                if (tipo_file === "R_TECNICO")
                    a.download = manifestazione.nome_pdf_regolamento_tecnico;
                document.body.appendChild(a); // append the element to the dom
                a.click();
                a.remove(); // afterwards, remove the element  
            })
            .catch(error => {
                console.error(error);
            });




    }




    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                    <DialogTitle id="alert-dialog-title">
                        Eliminare questo record?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Sei sicuro di voler eliminare questo record?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <MDButton onClick={handleClose}>No</MDButton>
                        <MDButton onClick={handleConfirm} autoFocus>
                            SI
                        </MDButton>
                    </DialogActions>
                </Dialog>



                <form >
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <HeaderForm titolo="Manifestazioni" save={handleSubmit(insert)} remove={handleOpen} exit={annulla} modo={modo} />


                                {error !== null &&
                                    <Alert color="error"><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>
                                }
                                <MDBox pt={4} pb={3} px={3}>
                                    <MDBox component="form" role="form">
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12} mb={2}>

                                                <MDInput type="text" label="Nome Manifestazione" fullWidth name="nome_manifestazione"
                                                    {...register('nome_manifestazione')} autocomplete="off"

                                                    error={errors.nome_manifestazione ? true : false} InputLabelProps={{ shrink: true }} />
                                                {
                                                    errors.nome_manifestazione ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.nome_manifestazione?.message}</span> : ''
                                                }
                                            </Grid>
                                            <Grid item xs={12} sm={12} mb={2} >
                                                <MDBox sx={{ display: 'grid', gap: 5, gridTemplateColumns: '3fr 3fr' }}>
                                                    <MDInput
                                                        type="file"
                                                        label="PDF Regolamento" fullWidth id="pdf_regolamento"
                                                        autocomplete="off"  {...register('pdf_regolamento')}
                                                        name="pdf_regolamento" InputLabelProps={{ shrink: true }}
                                                    />
                                                    <MDTypography
                                                        variant="button"
                                                        fontWeight="regular"
                                                        color="text"
                                                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                                        onClick={download_pdf_regolamento}
                                                    >
                                                        {manifestazione.nome_pdf_regolamento}
                                                    </MDTypography>
                                                </MDBox>
                                                {
                                                    errors.pdf_regolamento ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.pdf_regolamento?.message}</span> : ''
                                                }
                                            </Grid>
                                            <Grid item xs={12} sm={12} mb={2}>
                                                <MDBox sx={{ display: 'grid', gap: 5, gridTemplateColumns: '3fr 3fr' }}>
                                                    <MDInput
                                                        type="file"
                                                        label="PDF Regolamento Tecnico di Quartiere" fullWidth id="pdf_regolamento_tecnico"
                                                        autocomplete="off"  {...register('pdf_regolamento_tecnico')}
                                                        name="pdf_regolamento_tecnico" InputLabelProps={{ shrink: true }}

                                                    />

                                                    <MDTypography
                                                        variant="button"
                                                        fontWeight="regular"
                                                        color="text"
                                                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                                        onClick={download_pdf_rt}
                                                    >
                                                        {manifestazione.nome_pdf_regolamento_tecnico}
                                                    </MDTypography>
                                                </MDBox>
                                                {
                                                    errors.pdf_regolamento_tecnico ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.pdf_regolamento_tecnico?.message}</span> : ''
                                                }
                                            </Grid>
                                            <Grid item xs={12} sm={6} mb={2}>
                                                <ReactHookFormCheckBox
                                                    label={<MDBox>
                                                        <MDTypography
                                                            variant="button"
                                                            fontWeight="regular"
                                                            color="text"
                                                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                                        >
                                                            &nbsp;&nbsp;Manifestazione Attiva&nbsp;
                                                        </MDTypography>

                                                    </MDBox>}
                                                    name="attiva"
                                                    control={control} />
                                            </Grid>
                                            <Grid item xs={12} sm={6} mb={2}>
                                                <ReactHookFormCheckBox
                                                    label={<MDBox>
                                                        <MDTypography
                                                            variant="button"
                                                            fontWeight="regular"
                                                            color="text"
                                                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                                        >
                                                            &nbsp;&nbsp;Iscrizioni Aperte&nbsp;
                                                        </MDTypography>

                                                    </MDBox>}
                                                    name="iscrizioni_aperte"
                                                    control={control} />
                                            </Grid>
                                            <Grid item xs={12} sm={6} mb={2}>
                                                <ReactHookFormSelect
                                                    id="stato_manifestazione"
                                                    name="stato_manifestazione"
                                                    label="Stato Manifestazione"
                                                    control={control}
                                                    defaultValue=''
                                                    variant="outlined"
                                                    required
                                                    error={errors.stato_manifestazione ? true : false}
                                                >

                                                    <MenuItem
                                                        key={0}
                                                        value={0}
                                                    >
                                                        0 - IN PREPARAZIONE
                                                    </MenuItem>
                                                    <MenuItem
                                                        key={1}
                                                        value={1}
                                                    >
                                                        1 - PROPOSTE DI PARTECIPAZIONE
                                                    </MenuItem>
                                                    <MenuItem
                                                        key={2}
                                                        value={2}
                                                    >
                                                        2 - POST ACCETTAZIONE
                                                    </MenuItem>
                                                    <MenuItem
                                                        key={10}
                                                        value={10}
                                                    >
                                                        10 - TERMINATA
                                                    </MenuItem>
                                                </ReactHookFormSelect>
                                            </Grid>
                                         
                                             
                                                <Grid item xs={12} sm={12} mb={2}>
                                                <MDBox>

                                                <ModuliList title="Moduli Obbligatori" allegati={lista_moduli} onDel={handleRemoveModulo}></ModuliList>
                                                <MDBox p={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr 1fr ' }}>
                                                <MDBox></MDBox>
                                 <MDButton color="black" size="small" onClick={aggiungi_riga}>Aggiungi</MDButton>
                                        
                                                </MDBox>
                                                </MDBox>
                                            </Grid>
                                        </Grid>


                                    </MDBox>
                                </MDBox>

                            </Card>
                        </Grid>
                    </Grid>
                </form>
            </MDBox>
            <ModuloEditModal
                onSave={handleAddModulo}
                onClose={handleShowClose}
                show={show}
                manifestazione={ manifestazione.nome_manifestazione}
                tipo_file="MODULO_OBBLIGATORIO"
            />

            <Footer />
        </DashboardLayout>
    );
}

export default ManifestazioneEdit;